// assets
import { ContactsOutlined } from '@ant-design/icons';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

// icons
const icons = {
    ContactsOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const users = {
  id: 'users-contactlist',
  title: 'User Management',
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: PersonIcon,
      breadcrumbs: true
    },
    {
        id: 'department',
        title: 'Departments',
        type: 'item',
        url: '/departments',
        icon: AccountTreeIcon,
        breadcrumbs: true
      },
      {
        id: 'branch',
        title: 'Branch / Locations',
        type: 'item',
        url: '/branch',
        icon: LocationOnIcon,
        breadcrumbs: true
      },
      {
        id: 'mysubscriptions',
        title: 'My Subscriptions',
        type: 'item',
        url: '/my-subscriptions',
        icon: WorkspacePremiumIcon,
        breadcrumbs: true
      },
       {
        id: 'transaction-report',
        title: 'Transaction Report',
        type: 'item',
        url: '/transaction-report',
        icon: SubscriptionsIcon,
        breadcrumbs: true
      },
 
      

    //   {
    //     id: 'changepassword',
    //     title: 'Update Password',
    //     type: 'item',
    //     url: '/update-password',
    //     icon: icons.ContactsOutlined,
    //     breadcrumbs: false
    //   },
    //   {
    //     id: 'changeprofile',
    //     title: 'Update Profile',
    //     type: 'item',
    //     url: '/update-profile',
    //     icon: icons.ContactsOutlined,
    //     breadcrumbs: false
    //   },
  ]
};

export default users;
